@if(result==1){<div class="--is-yes__tag">{{ 'label_yes' | translate}}</div>}
@if(result==2){<div class="--is-no__tag">{{ 'label_no' | translate}}</div>}